
import { mapGetters } from 'vuex'
import BargainSettings from './BargainSettings.vue'
import PricePopover from './PricePopover.vue'
import PricePopover2 from './PricePopover2.vue'
import MessageItem from './MessageItem.vue'
import { debounce } from '@/utils'
import { bargainStatus } from '@/enum/localEnum'
import BargainDialog from '@/components/BargainDialog.vue'
import { conversationTime } from '@/utils/index'

export default {
    name: 'ImBargaining',
    components: {
        BargainSettings,
        PricePopover,
        MessageItem,
        PricePopover2,
        BargainDialog
    },
    props: {
        userinfo: {
            type: Object,
            default: () => ({})
        },
        conversation: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        const validatePrice = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入报价'))
            } else if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
                callback(new Error('请输入有效价格'))
            } else if (value >= this.detailsData.price) {
                callback(new Error('砍价不能大于商品原价，请重新输入'))
            } else if (value < this.detailsData.price * 0.7) {
                callback(new Error('商品砍价不能低于商品价格的70%，请重新输入'))
            } else {
                callback()
            }
        }
        return {
            bargainSettingsVisible: false,
            // 出价弹窗相关
            pricePopoverVisible: false,
            currentAction: '', // 记录当前操作类型
            currentItem: null, // 记录当前操作的消息项
            buttonConfigs: {
                buyerUpdatePrice: [{ text: '修改出价', action: 'update' }],
                buyerBidOrBuy: [
                    { text: '出价', action: 'bid' },
                    { text: '立即购买', action: 'buy' }
                ],
                buyOnly: [{ text: '立即购买', action: 'buy' }],

                sellerAll: [
                    { text: '拒绝', action: 'reject' },
                    { text: '还价', action: 'dicker' },
                    { text: '同意', action: 'accept' }
                ],
                sellerLastRound: [
                    { text: '拒绝', action: 'reject' },
                    { text: '同意', action: 'accept' }
                ]
            },
            // 状态按钮文本
            statusButtonText: '出价',
            // 出价/修改价格loading
            priceLoading: false,
            // 出价/修改价格验证
            priceRules: {
                price: [
                    {
                        required: true,
                        validator: validatePrice,
                        trigger: 'blur'
                    }
                ]
            },
            // 出价/修改价格表单
            priceFrom: {
                price: null
            },
            // 当前出价信息
            counterOfferInfo: null,
            // 修改价格弹窗2
            pricePopoverVisible2: false,
            // 倒计时数据
            countdownTime: '00:00:00',
            countdownTimer: null,
            remainingTime: 0,
            // 重新出价弹窗
            dialogKanVisible: false,
            // 砍价信息
            bargainCheck: null,
            // 砍价弹窗loading
            bargainLoading: false,
            confirmDialogVisible: false
        }
    },
    computed: {
        ...mapGetters({
            currentBargain: 'bargaining/currentBargain',
            bargainImMessageTop: 'bargaining/bargainImMessageTop',
            bargainHistory: 'bargaining/bargainHistory',
            foldedBargainList: 'bargaining/foldedBargainList',
            bargainUserInfo: 'bargaining/bargainUserInfo',
            bargainImEvent: 'bargaining/bargainImEvent',
            buyerButtons: 'bargaining/buyerButtons',
            sellerButtons: 'bargaining/sellerButtons'
        }),
        // 显示捎一句话按钮
        showOther () {
            const isBuyer = this.bargainImMessageTop?.isBuyer
            const buttons = isBuyer ? this.buyerButtons : this.sellerButtons
            return buttons && buttons.find(item => item.eventType === 'JUST_ONE_SENTENCE')
        },
        // 底部按钮数据
        bargainingBottomButton () {
            const { isBuyer, orderNo, orderStatus } = this.bargainImMessageTop || {}
            const buttons = isBuyer ? this.buyerButtons : this.sellerButtons
            let obj = null
            if (orderNo && orderStatus && isBuyer) {
                switch (orderStatus) {
                case 'NOT_PAID': {
                    obj = {
                        text: '去支付',
                        type: 'SELLER_ORDER_NO_PAY'
                    }
                    break
                }
                // case 'PAID': {
                //     obj = {
                //         text: "已支付",
                //         type: "PAID"
                //     }
                //     break;
                // }
                case 'CANCELLED': {
                    obj = {
                        text: '重新出价',
                        type: 'INITIATE_BARGAIN'
                    }
                    break
                }
                default:
                    break
                }
                return obj
            }
            buttons.forEach(item => {
                if (item.eventType === 'INITIATE_BARGAIN') {
                    obj = {
                        text: '重新出价',
                        type: 'INITIATE_BARGAIN'
                    }
                }
                if (item.eventType === 'SELLER_AGREE') {
                    obj = {
                        text: '同意出价',
                        type: 'SELLER_AGREE'
                    }
                }
                if (item.eventType === 'BUY_NOW') {
                    obj = {
                        text: '立即购买',
                        type: 'BUY_NOW'
                    }
                }
                if (item.eventType === 'SELLER_ORDER_NO_PAY') {
                    obj = {
                        text: '去支付',
                        type: 'SELLER_ORDER_NO_PAY'
                    }
                }
            })
            if (!obj) {
                const lastItem = this.bargainHistory[this.bargainHistory.length - 1]
                if (lastItem?.uid === this.userinfo.id && this.bargainImMessageTop?.isBuyer) {
                    obj = {
                        text: '请等待卖家回复',
                        type: 'WAIT_SELLER_REPLY'
                    }
                }
            }
            return obj
        },
        // 是否显示倒计时
        showCountdown () {
            return this.bargainImMessageTop?.orderStatus === 'NOT_PAID' && this.bargainImMessageTop?.payEndTime && this.bargainImMessageTop?.payEndTime > 0
        }
    },
    watch: {
        // 监听当前会话变化，重新加载数据
        currentBargain: {
            handler (newVal) {
                if (newVal && newVal.sessionId) {
                    this.loadBargainData()
                }
            },
            deep: true
        },
        // 监听top变化
        bargainImMessageTop: {
            handler (newVal) {
                // 获取出价信息
                newVal && Object.keys(newVal).length && this.getCounterOfferInfo()
                // 启动倒计时
                this.startCountdown()
                // 商品价格变化提示
                if (newVal?.isGoodsPriceChange) {
                    this.$message.warning('商品价格已修改，请重新出价')
                }
            },
            immediate: true
        },
        // 监听消息历史记录变化，自动滚动到底部
        bargainHistory: {
            handler () {
                this.scrollToBottom()
            },
            deep: true
        }
    },
    mounted () {
        // 如果已经有currentBargain数据，则加载砍价数据
        if (this.currentBargain && this.currentBargain.sessionId) {
            this.loadBargainData()
        }
        // 启动倒计时
        this.startCountdown()
        // 初始化时滚动到底部
        this.scrollToBottom()
    },
    beforeDestroy () {
        // 组件销毁前清除定时器
        this.clearCountdown()
    },
    methods: {
        // 会话列表时间
        conversationTime (time) {
            return conversationTime(time)
        },
        openBargainSettings () {
            this.bargainSettingsVisible = true
        },

        // 加载砍价会话相关数据
        loadBargainData () {
            this.$store.dispatch('bargaining/loadBargainData')
        },

        // 选择砍价项
        selectBargainItem (item) {
            // 更新当前砍价，移除折叠标识
            const updatedBargain = {
                ...this.currentBargain,
                isFolded: false
            }

            // 如果有sessionId，使用item的sessionId
            if (item.sessionId) {
                updatedBargain.sessionId = item.sessionId
            }

            // 提交更新
            this.$store.commit('bargaining/SET_CURRENT_BARGAIN', updatedBargain)

            // 获取砍价历史记录
            this.$api.bargainImMessageHistoryAPI({
                limit: 100,
                msgIds: [],
                offsetId: 0,
                up: true,
                sessionId: updatedBargain.sessionId
            }).then(res => {
                if (res.success) {
                    // 处理res.data中的ex字段，将字符串转换为对象
                    if (res.data && Array.isArray(res.data)) {
                        const processedData = res.data.map(item => {
                            if (item.ex && typeof item.ex === 'string') {
                                try {
                                    item.ex = JSON.parse(item.ex)
                                } catch (error) {
                                    console.error('解析ex字段失败:', error)
                                }
                            }
                            return item
                        })
                        this.$store.commit('bargaining/SET_BARGAIN_HISTORY', processedData)

                        // 获取最后一条对方发送的消息
                        const lastOpponentMessage = processedData
                            .filter(item => item.uid !== this.userinfo.id) // 过滤出对方发送的消息
                            .sort((a, b) => new Date(b.createTime) - new Date(a.createTime)) // 按发送时间倒序排列
                            .find(item => item) // 获取最新的一条

                        if (lastOpponentMessage) {
                            console.log('最后一条对方发送的消息:', lastOpponentMessage)
                            // 这里可以根据需要处理最后一条对方消息的逻辑
                            this.$api.bargainImMessageBatchAckAPI({
                                offsetId: lastOpponentMessage?.offsetId,
                                sessionId: lastOpponentMessage?.sessionId
                            }).then(res => {
                                console.log(res, '批量确认消息已读123', item)
                                // 接口调用成功后，清空当前会话的未读数
                                if (res.success) {
                                    this.$store.commit('bargaining/CLEAR_BARGAIN_UNREAD_COUNT', lastOpponentMessage?.sessionId)
                                    // 同时减少总未读数
                                    const currentAllUnreadCount = this.$store.getters['bargaining/bargainUnReadMsgCount'] || 0
                                    if (currentAllUnreadCount > 0) {
                                        this.$store.commit('bargaining/SET_BARGAIN_UNREAD_MESSAGE_COUNT', currentAllUnreadCount - 1)
                                    }
                                }
                            })
                        }
                    } else {
                        this.$store.commit('bargaining/SET_BARGAIN_HISTORY', [])
                    }
                }
            })
        },

        // 消息按钮
        messageBtn (item, actionType) {
            console.log('按钮点击:', item, actionType)

            // 根据操作类型执行不同操作
            switch (actionType) {
            case 'buy': {
                // 立即购买
                this.buyNow()
                // const { bargainOrderType, imUserId, goodsNo, orderNo } = this.bargainImMessageTop || {}
                // // 线下
                // if (Number(bargainOrderType) === bargainStatus.MY_BARGAIN_ENUM.OffLine) {
                //     if (!imUserId) return this.$message.error('暂无客服')
                //     // 413砍价线下单直接跳转客服聊天
                //     this.$store.dispatch('ry/join', { targetId: imUserId, conversationType: 1 })
                //     return
                // }
                // // 线上
                // if (orderNo) {
                //     this.$router.push(`/account/buyerDetails?orderNo=${orderNo}`)
                //     return
                // }
                // const order = {
                //     bargainOrderNo: this.bargainImMessageTop?.bargainOrderNo,
                //     bargainPrice: this.counterOfferInfo?.transactionPrice,
                //     gameId: this.bargainImMessageTop?.gameId
                // }
                // sessionStorage.setItem('orderDtl', JSON.stringify(order))
                // // 没有生成订单则跳转到砍价的订单确认页
                // this.$router.push(`/confirmOrder/onlinePay?goodsNo=${goodsNo}`)
                // 为啥要用 sessionStorage 来传数据！！！
                break
            }
            case 'dicker':
                console.log('执行卖家还价操作')
                this.pricePopoverVisible2 = true
                this.currentAction = 'dicker'
                break
            case 'bid':
                console.log('执行买家出价操作')
                this.pricePopoverVisible2 = true
                this.currentAction = 'bid'
                break

            case 'accept':
                // 同意出价
                console.log('执行同意操作')
                this.pricePopoverVisible2 = true
                this.currentAction = 'accept'
                // this.$api.bargainImSellerAgreeAPI({
                //     action: {
                //         bargainId: this.bargainImMessageTop.id,
                //         buyerId: this.bargainImMessageTop.buyerId,
                //         goodsNo: this.bargainImMessageTop.goodsNo,
                //         sellerId: this.bargainImMessageTop.sellerId
                //     }
                // }).then(({ success, info }) => {
                //     if (success) {
                //         this.$message.success('同意出价成功')
                //     } else {
                //         this.$message.error(info)
                //     }
                // })
                break
            case 'reject':
                // 拒绝出价
                console.log('执行拒绝操作')
                this.$api.bargainImSellerRefuseCounterOfferAPI({
                    action: {
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }).then(({ success, info }) => {
                    if (!success) {
                        this.$message.error(info || '操作失败~')
                    }
                    this.$trackEvent({ eventType: 'click', trackParams: { eventName: '拒绝出价', userId: this.userinfo?.id, goodsNo: this.bargainImMessageTop?.goodsNo, isSuccess: success } })
                })
                break

            case 'update':
                // 修改出价
                console.log('执行修改出价操作')
                this.pricePopoverVisible2 = true
                this.currentAction = 'update'
                break

            default:
                console.log('未知操作类型:', actionType)
            }
        },

        // 提交出价
        handlePriceSubmit (data) {
            // 买家修改出价
            if (data.action === 'update') {
                this.$api.bargainImBuyerUpdatePriceAPI({
                    action: {
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        price: data.price,
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }).then(res => {
                    this.$trackEvent({ eventType: 'click', trackParams: { eventName: '修改出价', userId: this.userinfo.id, goodsNo: this.bargainImMessageTop.goodsNo, isSuccess: res.success } })
                    if (res.success) {
                        this.$message.success('修改出价成功')
                    } else {
                        this.$message.error(res.info)
                    }
                })
            }
            // 买家出价
            if (data.action === 'bid') {
                this.$api.bargainImBuyerCounterOfferAPI({
                    action: {
                        againOffer: false,
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        price: data.price,
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }).then(res => {
                    if (res.success) {
                        this.$message.success('出价成功')
                    } else {
                        this.$message.error(res.info)
                    }
                })
            }
            // 卖家还价
            if (data.action === 'dicker') {
                this.$api.bargainImSellerCounterOfferAPI({
                    action: {
                        bargainId: this.bargainImMessageTop.id,
                        buyerId: this.bargainImMessageTop.buyerId,
                        goodsNo: this.bargainImMessageTop.goodsNo,
                        price: data.price,
                        sellerId: this.bargainImMessageTop.sellerId
                    }
                }).then(res => {
                    this.$trackEvent({ eventType: 'click', trackParams: { eventName: '卖家还价', userId: this.userinfo?.id, goodsNo: this.bargainImMessageTop?.goodsNo, isSuccess: res.success, replyRound: bargainImEvent?.round } })
                    if (res.success) {
                        this.$message.success('还价成功')
                    } else {
                        this.$message.error(res.info)
                    }
                })
            }
        },

        // 显示底部按钮对应的操作界面
        showCurrentActionButtons () {
            console.log(this.buyerButtons, '买家按钮')
            // 根据用户身份和当前会话状态设置当前操作类型
            const isBuyer = this.bargainImMessageTop?.isBuyer

            // 根据角色和上下文设置操作类型
            if (isBuyer) {
                this.currentAction = 'bargain' // 买家默认出价操作
            } else {
                this.currentAction = 'bargain' // 卖家默认还价操作
            }

            // 显示出价悬浮框
            this.pricePopoverVisible = true
        },

        getButtonsByStatus (item) {
            // 判断当前用户是否是买家
            const isBuyer = this.bargainImMessageTop?.isBuyer
            // 判断消息是否由当前用户发送
            const isSelfMessage = this.userinfo.id === item?.uid
            let buttons = []
            switch (item?.ex?.type) {
            // 出价卡片
            case 'PRICE_CARD': {
                if (isBuyer) {
                    if (item?.ex?.isUpdatePrice) {
                        buttons = this.buttonConfigs.buyerUpdatePrice
                    }
                } else {
                    buttons = item?.ex?.isLastRound ? this.buttonConfigs.sellerLastRound : this.buttonConfigs.sellerAll
                }
                break
            }
            // 系统消息
            case 'SYSTEM_MSG':
            // 没有按钮的卡片消息
            case 'NORMAL_CARD':
            // 普通消息，稍一句话场景使用
            case 'NORMAL_MSG':
            // 拒绝卡片
            case 'REJECT_CARD':
            // 自动拒绝卡片
            case 'AUTO_REJECT_CARD':
            // 买家下单支付取消订单
            case 'SELLER_ORDER_CANCEL_CARD':
                buttons = []
                break
            // 还价卡片
            case 'COUNTER_OFFER_CARD':
                if (isBuyer && !isSelfMessage) {
                    buttons = this.buttonConfigs.buyerBidOrBuy
                }
                if (!isBuyer && !isSelfMessage) {
                    buttons = item?.ex?.isLastRound ? this.buttonConfigs.sellerLastRound : this.buttonConfigs.sellerAll
                }
                break
            // 同意卡片
            case 'AGREE_CARD':
                break
            // 自动同意卡片
            case 'AUTO_AGREE_CARD':
                break
            // 自动还价卡片
            case 'AUTO_COUNTER_OFFER_CARD':
                break
            // 买家下单未支付卡片
            case 'SELLER_ORDER_NO_PAY_CARD':
                break
            default:
                break
            }
            return buttons
        },

        // 发送捎一句话
        handleSendSubmit (msg) {
            const params = {
                action: {
                    msg,
                    bargainId: this.bargainImMessageTop.id,
                    buyerId: this.bargainImMessageTop.buyerId,
                    sellerId: this.bargainImMessageTop.sellerId
                }
            }
            this.$api.bargainImBuyerSendScriptAPI(params).then(res => {
                this.$trackEvent({ eventType: 'click', trackParams: { eventName: '稍一句话', userId: this.userinfo.id, goodsNo: this.bargainImMessageTop.goodsNo, bidTime: Date.now(), isSuccess: res.success } })
                if (res.success) {
                    this.$message.success('发送成功')
                    this.loadBargainData()
                } else {
                    this.$message.error(res.info)
                }
            })
        },

        // 底部按钮事件
        bargainingBottomBtn () {
            const { type } = this.bargainingBottomButton || {}
            console.log(type, '123123')
            switch (type) {
            // 重新出价
            case 'INITIATE_BARGAIN': {
                // this.pricePopoverVisible2 = true
                this.currentAction = 'reBid'
                this.showKan()
                break
            }
            // 同意出价
            case 'SELLER_AGREE': {
                this.pricePopoverVisible2 = true
                this.currentAction = 'accept'
                // this.$api.bargainImSellerAgreeAPI({
                //     action: {
                //         bargainId: this.bargainImMessageTop.id,
                //         buyerId: this.bargainImMessageTop.buyerId,
                //         goodsNo: this.bargainImMessageTop.goodsNo,
                //         sellerId: this.bargainImMessageTop.sellerId
                //     }
                // }).then(({ success, info }) => {
                //     if (success) {
                //         this.$message.success('同意出价成功')
                //     } else {
                //         this.$message.error(info)
                //     }
                // })
                break
            }
            // 立即购买
            case 'BUY_NOW': {
                // 立即购买
                this.buyNow()
                break
            }
            // 去支付
            case 'SELLER_ORDER_NO_PAY':
                console.log('执行去支付操作')
                const { orderNo } = this.bargainImMessageTop || {}
                this.$router.push(`/account/buyerDetails?orderNo=${orderNo}`)
                break
            default:
                break
            }
        },
        // 获取出价信息
        getCounterOfferInfo () {
            // 打开弹窗前获取当前出价信息
            const params = {
                action: {
                    bargainId: this.bargainImMessageTop.id,
                    buyerId: this.bargainImMessageTop.buyerId,
                    goodsNo: this.bargainImMessageTop.goodsNo,
                    sellerId: this.bargainImMessageTop.sellerId
                }
            }
            this.$api.bargainImCounterOfferInfoAPI(params).then(res => {
                if (res.success) {
                    this.counterOfferInfo = res.data
                }
            })
        },
        // 开始倒计时
        startCountdown () {
            // 清除旧的定时器
            this.clearCountdown()

            // 如果有剩余时间且大于0，开始倒计时
            if (this.bargainImMessageTop?.payEndTime && this.bargainImMessageTop.payEndTime > 0) {
                // 设置初始剩余时间
                this.remainingTime = this.bargainImMessageTop.payEndTime
                this.updateCountdown()
                this.countdownTimer = setInterval(() => {
                    // 每秒减少1000毫秒
                    this.remainingTime = Math.max(0, this.remainingTime - 1000)
                    this.updateCountdown()

                    // 如果倒计时结束，清除定时器并调用结束函数
                    if (this.remainingTime <= 0) {
                        this.clearCountdown()
                        this.handleCountdownEnd()
                    }
                }, 1000)
            }
        },

        // 更新倒计时
        updateCountdown () {
            let leftTime = this.remainingTime

            if (leftTime <= 0) {
                this.countdownTime = '00:00:00'
                return
            }

            // 计算时分秒
            const hours = Math.floor(leftTime / (1000 * 60 * 60))
            leftTime -= hours * 1000 * 60 * 60
            const minutes = Math.floor(leftTime / (1000 * 60))
            leftTime -= minutes * 1000 * 60
            const seconds = Math.floor(leftTime / 1000)

            // 格式化时间
            this.countdownTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        },

        // 清除倒计时
        clearCountdown () {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer)
                this.countdownTimer = null
            }
        },

        // 倒计时结束处理函数
        handleCountdownEnd () {
            // 倒计时结束后的逻辑，此处为空函数，由用户自行实现
        },
        /** 砍价 **/
        showKan: debounce(async function () {
            const params = {
                action: {
                    goodsNo: this.bargainImMessageTop?.goodsNo,
                    userId: this.userinfo.id
                }
            }
            this.$api.bargainImEntranceCheckAPI(params).then(({ success, data, info }) => {
                if (success && data) {
                    // 检查砍价信息
                    this.bargainCheck = data
                    this.dialogKanVisible = true
                } else {
                    this.$message.error(info)
                }
            })
        }),
        // 处理砍价表单提交
        handleBargainSubmit (price) {
            const params = {
                action: {
                    goodsNo: this.bargainImMessageTop?.goodsNo,
                    price: parseFloat(price),
                    buyerId: this.userinfo.id
                }
            }
            this.bargainLoading = true
            this.$api.bargainImCreateAPI(params).then(res => {
                if (!res.success) {
                    this.bargainLoading = false
                    if (res.code === 'BARGAIN_IM_REPETITION') {
                        const model = this.$pzDialog(
                            {
                                width: '450px',
                                title: '温馨提示',
                                titleCenter: true,
                                confirmButtonText: '',
                                cancelButtonText: '我知道了',
                                content: res.info,
                                contentCenter: true,
                                showConfirmButton: false,
                                onCancel: () => {
                                    model.remove()
                                }
                            },
                            this
                        )
                        return
                    }

                    this.$message.error(res.info)
                    return
                }
                const { sellerAgree, sellerReject, sellerReply } = res?.data?.operate || {}
                sellerAgree && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '同意砍价', ...sellerAgree } })
                sellerReject && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '卖家拒绝', ...sellerReject } })
                sellerReply && this.$trackEvent({ eventType: 'click', trackParams: { eventName: '砍价回复', ...sellerReply } })
                setTimeout(() => {
                    this.bargainLoading = false
                    this.dialogKanVisible = false
                    this.$message.success('砍价成功~')
                    // 重新获取砍价盒子
                    this.$store.dispatch('bargaining/getBargainBoxList')
                }, 1000)
            }).catch(err => {
                this.bargainLoading = false
                console.error(err)
            })
        },
        // 跳转商品详情
        goGoodsDetail () {
            this.$router.push(`/goodsDetails/${this.bargainImMessageTop?.goodsNo}`)
        },
        // 购买
        buyNow () {
            const { bargainOrderType, imUserId, goodsNo, orderNo } = this.bargainImMessageTop || {}
            // 线下
            if (Number(bargainOrderType) === bargainStatus.MY_BARGAIN_ENUM.OffLine) {
                this.confirmDialogVisible = true
                return
                if (!imUserId) { return this.$message.error('暂无客服') }
                // 413砍价线下单直接跳转客服聊天
                this.$store.dispatch('ry/join', { targetId: imUserId, conversationType: 1 })
                return
            }
            // 线上
            if (orderNo) {
                this.$router.push(`/account/buyerDetails?orderNo=${orderNo}`)
                return
            }

            // 砍价价格大于秒杀价格
            if (this.counterOfferInfo?.transactionPrice > this.bargainImMessageTop?.goodsPrice) {
                let countdown = 3
                const model = this.$pzDialog(
                    {
                        width: '450px',
                        title: '温馨提示',
                        titleCenter: true,
                        showClose: true,
                        cancelButtonText: '我知道了',
                        confirmButtonText: `立即购买(${countdown}s)`,
                        content: '当前商品正在限时秒杀，价格比当前更低哦，已为您获取最低价格',
                        contentCenter: false,
                        onConfirm: () => {
                            model.remove()
                            this.goToOrderPageWithSeckillPrice(this.bargainImMessageTop?.goodsPrice )
                        },
                        onCancel: () => {
                            model.remove()
                        }
                    },
                    this
                )

                // 倒计时
                const timer = setInterval(() => {
                    countdown--
                    if (countdown > 0) {
                        model.options.confirmButtonText = `立即购买(${countdown}s)`
                    } else {
                        clearInterval(timer)
                        model.remove()
                        this.goToOrderPageWithSeckillPrice(this.bargainImMessageTop?.goodsPrice )
                    }
                }, 1000)

                // 弹窗关闭时清除定时器
                const originalRemove = model.remove
                model.remove = () => {
                    clearInterval(timer)
                    originalRemove.call(model)
                }
                return
            }

            //砍价价格创建订单
            this.goToOrderPageWithSeckillPrice(this.counterOfferInfo?.transactionPrice)
        },
        confirmBargainSwitch () {
            this.$api.bargainImBuyerAgreeAPI({
                bargainOrderNo: this.bargainImMessageTop?.bargainOrderNo
            }).then(({ success, info }) => {
                if (success) {
                    const { imUserId } = this.bargainImMessageTop || {}
                    this.confirmDialogVisible = false
                    if (!imUserId) { return this.$message.error('暂无客服') }
                    // 413砍价线下单直接跳转客服聊天
                    this.$store.dispatch('ry/join', { targetId: imUserId, conversationType: 1 })
                } else {
                    this.$message.error(info)
                }
            })
        },

        cancelBargainSwitch () {
            // 关闭确认弹窗
            this.confirmDialogVisible = false
        },
        // 滚动到底部
        scrollToBottom () {
            this.$nextTick(() => {
                if (this.$refs.messageList) {
                    this.$refs.messageList.scrollTop = this.$refs.messageList.scrollHeight
                }
            })
        },

        /**
         * 跳转到订单页
         */
        goToOrderPageWithSeckillPrice(price) {
            const goodsNo = this.bargainImMessageTop?.goodsNo

            const order = {
                bargainOrderNo: this.bargainImMessageTop?.bargainOrderNo,
                bargainPrice: price,
                gameId: this.bargainImMessageTop?.gameId,
            }
            sessionStorage.setItem('orderDtl', JSON.stringify(order))
            this.$router.push(`/confirmOrder/onlinePay?goodsNo=${goodsNo}`)
        }
    }

}
